// Module
var code = `<!-- blFigure — blog image with caption.
     Data shape: { src, alt, caption } -->
<figure>
  <img src="{{src}}" alt="{{alt}}">
  <figcaption>{{caption}}</figcaption>
</figure>
`;
// Exports
module.exports = code;